import { fetchTransformationPage } from "../services/contentApi";
import { ServicePageProvider, useServicePage, useServiceSection } from "./ServicePageContext";

export function TransformationPageProvider({ children }) {
  return (
    <ServicePageProvider fetchPage={fetchTransformationPage}>
      {children}
    </ServicePageProvider>
  );
}

export const useTransformationPage = useServicePage;
export const useTransformationSection = useServiceSection;
